import { useEffect } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { UPDATE_LOOKING_FOR } from "../../../navigation/Constants"
import { RootState } from "../../../redux/store"
import { getQuestionById } from "../../../services/questionService"
import { QuestionEditProfileDataState } from "../../../typings/editProfile"


export interface MoreQuestionSectionProps {
   questions: QuestionEditProfileDataState[]
}

const MoreQuestionSection = ({ questions }: MoreQuestionSectionProps) => {
   return (
      <ul className="prior_links_list w-list-unstyled">

         {questions.map((question, index) => {
            return <li key={index} className="prior_link_item">
               <Link className="prior_link w-inline-block" to={{ pathname: `/updateQuestionTag/${question.questionId}` }}>
                  {/* <div className="prior_icon_block">
                     <img src="/assets/images/ic_info_smoke.svg" loading="lazy" alt="" />
                  </div> */}
                  <div className="prior_link_info w-clearfix" style={{ textAlign: 'right' }}>
                     <h4 className="prior_link_title">{question.questionText}</h4>
                     {question.answers.length !== 0 && question.answers[0] !== 'לא רלוונטי' && <p>{question.answers.filter(a => a !== 'לא רלוונטי').join(', ')}</p>}
                     {
                        question.answers.length > 0 && question.answers[0] !== 'לא רלוונטי' ?
                           <div className="prior_status_block w-clearfix">
                              <div>עריכה</div>
                              <img src="assets/images/prior_arrow.svg" loading="lazy" alt="" className="prior_stat_icon" />
                           </div>
                           :
                           <div className="prior_status_block black w-clearfix">
                              <div>הוספה</div>
                              <img src="assets/images/prior_arrow.svg" loading="lazy" alt="" className="prior_stat_icon" />
                           </div>
                     }
                  </div>
               </Link>
               <div className="prior_item_line" />
            </li>

         })


         }
      </ul>
   )
}

export default MoreQuestionSection